import { render, staticRenderFns } from "./IDCardVerify.vue?vue&type=template&id=97932726&scoped=true&"
import script from "./IDCardVerify.vue?vue&type=script&lang=ts&"
export * from "./IDCardVerify.vue?vue&type=script&lang=ts&"
import style0 from "./IDCardVerify.vue?vue&type=style&index=0&id=97932726&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97932726",
  null
  
)

export default component.exports